<template>
  <div
    class="truncate truncated-description-field"
    ref="wrapper"
  >
    <span
      ref="field"
      :id="uniqueId"
    >
      {{ value }}
    </span>
      <b-tooltip
        v-if="showTooltip"
        placement="bottom"
        :target="uniqueId"
      >
       {{ value }}
      </b-tooltip>
  </div>
</template>

<script>
export default {
  name: 'DefaultDescriptionField',
  props: {
    value: {
      type: String,
      default: '',
    },
    uniqueId: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    showTooltip: false,
  }),
  mounted() {
    this.setTooltipVisible();
  },
  methods: {
    setTooltipVisible() {
      const { wrapper, field } = this.$refs;
      if (wrapper.offsetWidth < field.offsetWidth) {
        this.showTooltip = true;
      }
    },
  },
};
</script>

